import { PAGE_TYPE } from "@/meta/common";
import { ARTICLE_TYPE } from "@/meta/manageCenter/article";
import type { RouteRecordRaw } from "vue-router";

export const userOperationRouter: RouteRecordRaw[] = [
    {
        path: "/userOperation",
        component: () => import("@/layouts/index.vue"),
        name: "UserOperation",
        meta: {
            title: "用户运营"
        },
        children: [
            {
                path: "sampleApply",
                name: "SampleApply",
                component: () => import("@/views/pages/tradeManage/sampleApply/index.vue"),
                meta: {
                    title: "用户申请寄样",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "SampleApply",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_APPLY_SAMPLE_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_APPLY_SAMPLE_DEAL"
                        }
                    ]
                }
            },
            {
                path: "sampleApply/detail",
                name: "SampleApplyDetail",
                component: () => import("@/views/pages/tradeManage/sampleApply/detail.vue"),
                meta: {
                    title: "用户申请寄样详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "SampleApply",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_APPLY_SAMPLE_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_APPLY_SAMPLE_DEAL"
                        }
                    ]
                }
            },
            {
                path: "fundingClues",
                name: "FundingClues",
                component: () => import("@/views/pages/tradeManage/fundingClues/index.vue"),
                meta: {
                    title: "用户申请资金",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_FUNDS_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_FUNDS_W"
                        }
                    ]
                }
            },
            {
                path: "fundingClues/detail",
                name: "FundingCluesDetail",
                component: () => import("@/views/pages/tradeManage/fundingClues/detail.vue"),
                meta: {
                    title: "用户申请资金详情",
                    hidden: true,
                    activeMenu: "FundingClues",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_FUNDS_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_FUNDS_W"
                        }
                    ]
                }
            },
            {
                path: "messageFeedback",
                name: "MessageFeedback",
                component: () => import("@/views/pages/manageCenter/messageManage/messageFeedback/index.vue"),
                meta: {
                    title: "用户留言反馈",
                    activeMenu: "MessageFeedback",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_FEEDBACK_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_SS_FEEDBACK_W"
                        }
                    ]
                }
            },
            {
                path: "messageFeedback/details",
                name: "MessageFeedbackDetails",
                component: () => import("@/views/pages/manageCenter/messageManage/messageFeedback/details.vue"),
                meta: {
                    title: "用户留言详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "MessageFeedback",
                    pageType: PAGE_TYPE.DETAIL.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_FEEDBACK_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_SS_FEEDBACK_W"
                        }
                    ]
                }
            },
            {
                path: "notificationManage",
                name: "NotificationManage",
                component: () => import("@/views/pages/manageCenter/notificationManage/index.vue"),
                meta: {
                    title: "平台通知",
                    activeMenu: "NotificationManage",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_NOTICE_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SS_NOTICE_W"
                        }
                    ]
                }
            },
            {
                path: "notificationAdd",
                name: "NotificationAdd",
                component: () => import("@/views/pages/manageCenter/notificationManage/add/index.vue"),
                meta: {
                    title: "新增通知",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "NotificationManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_NOTICE_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SS_NOTICE_W"
                        }
                    ]
                }
            },
            {
                path: "NotificationEdit",
                name: "NotificationEdit",
                component: () => import("@/views/pages/manageCenter/notificationManage/add/index.vue"),
                meta: {
                    title: "编辑通知",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "NotificationManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_NOTICE_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SS_NOTICE_W"
                        }
                    ]
                }
            },
            {
                path: "notificationInfo",
                name: "NotificationInfo",
                component: () => import("@/views/pages/manageCenter/notificationManage/info/index.vue"),
                meta: {
                    title: "通知详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "NotificationManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SS_NOTICE_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SS_NOTICE_W"
                        }
                    ]
                }
            },
            {
                path: "adBanner",
                name: "AdBanner",
                meta: {
                    icon: "icon-Frame-11",
                    title: "广告管理"
                },
                children: [
                    {
                        path: "banner",
                        name: "Banner",
                        component: () => import("@/views/pages/manageCenter/adBanner/banner/index.vue"),
                        meta: {
                            title: "移动端",
                            activeMenu: "Banner",
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_SS_AD_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "ad",
                        name: "Ad",
                        component: () => import("@/views/pages/manageCenter/adBanner/ad/index.vue"),
                        meta: {
                            title: "PC端",
                            activeMenu: "Ad",
                            isNotShowHeader: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_SS_AD_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "adEdit",
                        name: "AdEdit",
                        component: () => import("@/views/pages/manageCenter/adBanner/ad/edit.vue"),
                        meta: {
                            title: "修改广告位",
                            activeMenu: "Ad",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "处理",
                                    value: "ROLE_SS_AD_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "twoEditType",
                        name: "TwoEditType",
                        component: () => import("@/views/pages/manageCenter/adBanner/ad/twoEditType.vue"),
                        meta: {
                            title: "修改广告位",
                            activeMenu: "Ad",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "处理",
                                    value: "ROLE_SS_AD_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "adPageManage",
                        name: "AdPageManage",
                        component: () => import("@/views/pages/manageCenter/adPageManage/index.vue"),
                        meta: {
                            title: "广告页管理",
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_LIST_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_AD_LIST_W"
                                }
                            ],
                            activeMenu: "AdPageManage"
                        }
                    },
                    {
                        path: "adPageManage/detail",
                        name: "AddDetail",
                        component: () => import("@/views/pages/manageCenter/adPageManage/info/index.vue"),
                        meta: {
                            title: "广告页详情",
                            hidden: true,
                            activeMenu: "AdPageManage",
                            isNotShowHeader: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_LIST_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_AD_LIST_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "addAd",
                        name: "addAd",
                        component: () => import("@/views/pages/manageCenter/adPageManage/addAD/index.vue"),
                        meta: {
                            title: "新增广告页",
                            hidden: true,
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "AdPageManage",
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_LIST_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_AD_LIST_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "adPageManage/edit",
                        name: "AddEdit",
                        component: () => import("@/views/pages/manageCenter/adPageManage/addAD/index.vue"),
                        meta: {
                            title: "修改广告页",
                            hidden: true,
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "AdPageManage",
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_AD_LIST_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_AD_LIST_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "popUpAdvert",
                        name: "PopUpAdvert",
                        component: () => import("@/views/pages/manageCenter/popUpAdvert/index.vue"),
                        meta: {
                            title: "弹窗广告",
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_POPUP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_POPUP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "popUpAdvert/add",
                        name: "AddPopUpAdvert",
                        component: () => import("@/views/pages/manageCenter/popUpAdvert/add.vue"),
                        meta: {
                            title: "新增弹框广告",
                            hidden: true,
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "PopUpAdvert",
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_SS_POPUP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "popUpAdvert/edit",
                        name: "EditPopUpAdvert",
                        component: () => import("@/views/pages/manageCenter/popUpAdvert/add.vue"),
                        meta: {
                            title: "修改弹框广告页",
                            hidden: true,
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "PopUpAdvert",
                            authOptions: [
                                {
                                    label: "管理",
                                    value: "ROLE_SS_POPUP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "popUpAdvert/detail",
                        name: "PopUpAdvertDetail",
                        component: () => import("@/views/pages/manageCenter/popUpAdvert/detail.vue"),
                        meta: {
                            title: "弹框广告详情",
                            hidden: true,
                            activeMenu: "PopUpAdvert",
                            isNotShowHeader: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_POPUP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_POPUP_W"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                path: "lianYunAbout",
                name: "LianYunAbout",
                meta: {
                    icon: "icon-Frame2",
                    title: "关于链云砂石"
                },
                children: [
                    {
                        path: "aboutUs",
                        name: "AboutUs",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.ABOUT_US.code },
                        meta: {
                            title: "关于我们",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ],
                            activeMenu: "AboutUs"
                        }
                    },
                    {
                        path: "userAgreement",
                        name: "UserAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.USER_AGREEMENT.code },
                        meta: {
                            title: "用户协议",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "UserAgreement",
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ]
                        }
                    },
                    {
                        path: "privacyAgreement",
                        name: "PrivacyAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.PRIVACY_AGREEMENT.code },
                        meta: {
                            title: "隐私政策",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "PrivacyAgreement",
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ]
                        }
                    },
                    {
                        path: "memberAgreement",
                        name: "MemberAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.MEMBER_AGREEMENT.code },
                        meta: {
                            title: "会员服务协议",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "MemberAgreement",
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ]
                        }
                    },
                    {
                        path: "helpCenter",
                        name: "HelpCenter",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/helpCenter/index.vue"),
                        meta: {
                            title: "帮助中心",
                            activeMenu: "HelpCenter",
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_HELP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_HELP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "aiPrivacyAgreement",
                        name: "AiPrivacyAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.AI_PRIVACY_AGREEMENT.code },
                        meta: {
                            title: "AI保护规则",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "AiPrivacyAgreement",
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ]
                        }
                    },
                    {
                        path: "aiUserAgreement",
                        name: "AiUserAgreement",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/article/index.vue"),
                        props: { type: ARTICLE_TYPE.AI_USER_AGREEMENT.code },
                        meta: {
                            title: "AI用户协议",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            activeMenu: "AiUserAgreement",
                            authOptions: [
                                {
                                    label: "查看/修改",
                                    value: "ROLE_SS_ABOUT"
                                }
                            ]
                        }
                    },
                    {
                        path: "helpCenter/info",
                        name: "HelpCenterInfo",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/helpCenter/info/index.vue"),
                        meta: {
                            title: "常见问题详情",
                            activeMenu: "HelpCenter",
                            isNotShowHeader: true,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_HELP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_HELP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "helpCenter/add",
                        name: "HelpCenterAdd",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/helpCenter/add/index.vue"),
                        meta: {
                            title: "新增常见问题",
                            activeMenu: "HelpCenter",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_HELP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_HELP_W"
                                }
                            ]
                        }
                    },
                    {
                        path: "helpCenter/edit",
                        name: "HelpCenterEdit",
                        component: () => import("@/views/pages/manageCenter/lianYunAbout/helpCenter/add/index.vue"),
                        meta: {
                            title: "编辑常见问题",
                            activeMenu: "HelpCenter",
                            pageType: PAGE_TYPE.CACHE_FORM.code,
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_SS_HELP_R"
                                },
                                {
                                    label: "管理",
                                    value: "ROLE_SS_HELP_W"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                path: "searchFound",
                name: "SearchFound",
                component: () => import("@/views/pages/manageCenter/tagManage/searchFound/index.vue"),
                meta: {
                    title: "搜索发现配置",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SEARCH_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_SEARCH_W"
                        }
                    ],
                    activeMenu: "SearchFound"
                }
            },
            {
                path: "appVersion",
                name: "AppVersion",
                component: () => import("@/views/pages/manageCenter/appVersion/index.vue"),
                meta: {
                    title: "APP版本管理",
                    activeMenu: "AppVersion",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SS_VERSION"
                        }
                    ]
                }
            }
        ]
    }
];

export default userOperationRouter;
